import { SxProps, Theme } from '@mui/material';

export const formContainerSx: SxProps<Theme> = {
  padding: 3,
  backgroundColor: '#1e1e1e',
  color: '#ffffff',
  borderRadius: 2,
  marginBottom: 2
};

export const formRowSx: SxProps<Theme> = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 2,
  marginBottom: 2
};

export const formFieldSx: SxProps<Theme> = {
  flex: '1 1 calc(50% - 16px)',
  minWidth: '240px'
};

export const sectionTitleSx: SxProps<Theme> = {
  fontWeight: 'bold',
  marginBottom: 2,
  color: 'primary.main'
};

export const customerDetailsContainerSx: SxProps<Theme> = {
  backgroundColor: '#1a1a1a',
  border: '1px solid #333',
  borderRadius: 2,
  marginBottom: 2,
  overflow: 'hidden'
};

export const customerHeaderSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: '#1976d2',
  color: 'white',
  padding: 2,
  borderRadius: 0
};

export const customerContentSx: SxProps<Theme> = {
  backgroundColor: '#2a2a2a',
  color: 'white',
  padding: 3
};

export const customerInfoGridSx: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
  gap: 3,
  marginBottom: 2
};

export const customerInfoFieldSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5
};

export const customerInfoLabelSx: SxProps<Theme> = {
  fontSize: '0.75rem',
  color: 'rgba(255, 255, 255, 0.7)',
  textTransform: 'uppercase',
  letterSpacing: '0.5px'
};

export const customerInfoValueSx: SxProps<Theme> = {
  fontSize: '0.875rem',
  color: 'white',
  fontWeight: 500
};

export const tripCreatedBoxSx: SxProps<Theme> = {
  p: 3,
  backgroundColor: 'rgba(76, 175, 80, 0.1)',
  borderRadius: 2,
  border: '1px solid rgba(76, 175, 80, 0.3)',
  mb: 3
};

export const tripCodeSx: SxProps<Theme> = {
  color: '#4caf50',
  fontWeight: 'bold',
  letterSpacing: 1,
  fontFamily: 'monospace',
  mb: 2
};

export const tripCreatedGridSx: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 2,
  mb: 2
};

export const tripCreatedActionsSx: SxProps<Theme> = {
  display: 'flex',
  gap: 2,
  mt: 3
};

export const customerEditFieldSx: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'rgba(255,255,255,0.05)',
    '& fieldset': { borderColor: 'rgba(255,255,255,0.3)' },
    '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.5)' },
    '&.Mui-focused fieldset': { borderColor: '#1976d2' }
  },
  '& .MuiInputLabel-root': { color: 'rgba(255,255,255,0.7)' },
  '& .MuiInputBase-input': { color: 'white' }
};

export const customerEditFieldDisabledSx: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'rgba(255,255,255,0.03)',
    '& fieldset': { borderColor: 'rgba(255,255,255,0.2)' }
  },
  '& .MuiInputLabel-root': { color: 'rgba(255,255,255,0.5)' },
  '& .MuiInputBase-input': { color: 'rgba(255,255,255,0.7)', WebkitTextFillColor: 'rgba(255,255,255,0.7)' }
};

export const customerEditSelectSx: SxProps<Theme> = {
  backgroundColor: 'rgba(255,255,255,0.05)',
  color: 'white',
  '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255,255,255,0.3)' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255,255,255,0.5)' },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#1976d2' },
  '& .MuiSvgIcon-root': { color: 'rgba(255,255,255,0.7)' }
};

export const customerEditAddressSx: SxProps<Theme> = {
  gridColumn: 'span 2',
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'rgba(255,255,255,0.05)',
    '& fieldset': { borderColor: 'rgba(255,255,255,0.3)' },
    '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.5)' },
    '&.Mui-focused fieldset': { borderColor: '#1976d2' }
  },
  '& .MuiInputLabel-root': { color: 'rgba(255,255,255,0.7)' },
  '& .MuiInputBase-input': { color: 'white' }
};

export const tripCreatedSimpleBoxSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  mt: 4,
  p: 4,
  backgroundColor: 'rgba(76, 175, 80, 0.1)',
  borderRadius: 2,
  border: '2px solid #4caf50'
};

export const tripCreatedSimpleCodeSx: SxProps<Theme> = {
  mb: 3,
  fontFamily: 'monospace'
};